export const calcPolylineTrafficRadiusByZoomLevel = ({
                                                         zoomLevel,
                                                         radius = 50,
                                                         radiusScale = 1,
                                                         softMaxWeight,
                                                         softMaxScale = 0.1,
                                                     }: {
    zoomLevel: number,
    radius: number,
    radiusScale?: number,
    softMaxWeight?: number,
    softMaxScale?: number,
}) => {

    const metresPerPixel = 40075016.686 * Math.abs(Math.cos(18 * 180 / Math.PI)) / Math.pow(2, zoomLevel + 8);
    const weight = Math.round((radius * radiusScale * 2 / metresPerPixel) + 2);

    if (!softMaxWeight || weight <= softMaxWeight) {
        return weight
    }

    // за стелею ширина далі росте, але вповільнено: інакше на близьких зумах
    // лінія або розповзається в «ковбасу» (чиста метрика),
    // або виглядає ниткою на тлі дороги (жорстка стеля)
    return Math.round(softMaxWeight + (weight - softMaxWeight) * softMaxScale);
}